import React from 'react';
import FacetPlanDataContainer from 'Components/FacetPlan/FacetPlanDataContainer';
import FacetPlanProvider from 'Components/FacetPlan/FacetPlanContext';

const FacetPlanAdvisorComponent = () => (
  <div test={'facet-plan'}>
    FacetPlan Advisor Placeholder
  </div>
);

const FacetPlan = () => {
  return (
    <FacetPlanProvider>
      <FacetPlanDataContainer component={FacetPlanAdvisorComponent} />
    </FacetPlanProvider>
  );
};

export default FacetPlan;
